import classNames from 'classnames';
import { forwardRef } from 'react';
const linkWrapperDisabledCss = "lxvw6lo";
const linkWrapperCss = "lnauspd";
export const LinkWrapper = forwardRef((props, ref) => {
  const {
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'a';
  return <Component ref={ref} {...restProps} className={classNames(linkWrapperCss, {
    [linkWrapperDisabledCss]: disabled
  }, props.className)} />;
});

require("./link_wrapper.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./link_wrapper.js");